// TODO: Agregar regex para obtener el id del video (ej. youtube/_cMxraX_5RE, https://www.youtube.com/watch?v=_cMxraX_5RE, etc)
export const OpenInYouTubeItem = (videoId) => {
  return (
    <div className="vds-menu" style={{ display: "contents" }}>
      <button
        className="vds-menu-item"
        tabIndex="-1"
        role="menuitem"
        aria-haspopup="menu"
        type="button"
        aria-hidden="false"
        onClick={() => window.open(`https://www.youtube.com/watch?v=${videoId.videoId}`, "_blank")}
      >
        <svg
          viewBox="0 0 24 24"
          className="vds-menu-item-icon vds-icon"
          fill="none"
          aria-hidden="true"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m10 15l5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9c.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83c-.25.9-.83 1.48-1.73 1.73c-.47.13-1.33.22-2.65.28c-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44c-.9-.25-1.48-.83-1.73-1.73c-.13-.47-.22-1.1-.28-1.9c-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83c.25-.9.83-1.48 1.73-1.73c.47-.13 1.33-.22 2.65-.28c1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44c.9.25 1.48.83 1.73 1.73"
            fill="currentColor"
          />
        </svg>
        <span className="vds-menu-item-label">Ver en YouTube</span>
        {/* <span className="vds-menu-item-hint"></span> */}
        {/* <svg
          viewBox="0 0 32 32"
          className="vds-menu-open-icon vds-icon"
          fill="none"
          aria-hidden="true"
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.947 16.095C17.999 16.043 17.999 15.9585 17.947 15.9065L11.6295 9.58899C11.3691 9.32864 11.3691 8.90653 11.6295 8.64618L13.2323 7.04341C13.4926 6.78306 13.9147 6.78306 14.1751 7.04341L21.0289 13.8973C21.0392 13.9064 21.0493 13.9158 21.0591 13.9257L22.6619 15.5285C22.9223 15.7888 22.9223 16.2109 22.6619 16.4713L14.1766 24.9565C13.9163 25.2169 13.4942 25.2169 13.2338 24.9565L11.631 23.3538C11.3707 23.0934 11.3707 22.6713 11.631 22.411L17.947 16.095Z"
            fill="currentColor"
          ></path>
        </svg> */}
      </button>
    </div>
  );
};
